import { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { useAuth } from "../app/AuthContext";

export function SiteHeader() {
  const { user, signOut } = useAuth();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  // Close on route change.
  useEffect(() => { setOpen(false); }, [location.pathname]);

  // Close on Escape.
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") setOpen(false); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  // Lock body scroll while menu is open.
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = open ? "hidden" : prev;
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  const isAdmin = user && (user.role === "admin" || user.role === "super_admin");
  const navItemClass = ({ isActive }: { isActive: boolean }) => isActive ? "active" : "";
  const onLogout = async () => {
    await signOut();
    setOpen(false);
  };

  return (
    <header className="site-header">
      <div className="container site-header__inner">
        <Link to="/" className="site-header__logo" onClick={() => setOpen(false)} aria-label="BeforeMainstream — home">
          Before<em>Mainstream</em>
        </Link>

        <button
          type="button"
          className="site-header__toggle"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          aria-controls="site-nav"
          onClick={() => setOpen((v) => !v)}
        >
          <span className="site-header__toggle-bars" aria-hidden="true" />
        </button>

        <nav id="site-nav" className={`site-header__nav ${open ? "is-open" : ""}`}>
          <NavLink to="/brands" className={navItemClass}>Brands</NavLink>
          <NavLink to="/categories" className={navItemClass}>Categories</NavLink>
          <NavLink to="/submit" className={navItemClass}>Submit</NavLink>
          {user && <NavLink to="/saved" className={navItemClass}>Saved</NavLink>}
          {isAdmin && <NavLink to="/admin" className={navItemClass}>Admin</NavLink>}
          {!user
            ? <NavLink to="/login" className={navItemClass}>Login</NavLink>
            : (
              <>
                <NavLink to="/saved">{user.displayName || user.email || "Account"}</NavLink>
                <button type="button" className="site-header__logout" onClick={onLogout}>Logout</button>
              </>
            )}
        </nav>
      </div>
    </header>
  );
}
